import { render, staticRenderFns } from "./MyPlan.vue?vue&type=template&id=9c4bf424"
import script from "./MyPlan.vue?vue&type=script&lang=ts"
export * from "./MyPlan.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports